import { cs1, ibm, port, ibdesk, soh, soh1, gamesoft } from "../assets/index";

export const myProjects = [
  {
    img: port,
    type: "Web Application",
    for: "Self",
    name: "Portfolio",
    tech: "React, JavaScript, SCSS, Tailwind CSS",
    url: "aaa-portfolio.web.app",
    desc: "Experience my portfolio project, a stunning web application crafted completely with the power of React JS. Explore my professional journey, showcased through an intuitive and visually appealing interface. Discover a seamless user experience, coupled with responsive design, making it accessible across all devices. Dive into a world of creativity and innovation, where my skills and expertise shine through this showcase of my work.",
  },
  {
    img: cs1,
    type: "Web Application",
    for: "Federal Urdu University, Pakistan",
    name: "CS-Talks",
    tech: "React, JavaScript, SCSS, PHP, SQL, Material, Bootstrap",
    url: "fuuastcstalks.com",
    desc: `
          Introducing "CS-Talks" a dedicated social web platform tailored exclusively for university students and educators, designed to create a vibrant and collaborative online ecosystem for the academic community. CS-Talks serves as an interactive digital hub where students, teachers, alumni, and professors can come together to build meaningful connections, enrich their learning experiences, and stay updated on the latest developments within their academic circles.
        \n  
          CS-Talks offers a multitude of features to facilitate engagement and collaboration. Students and teachers alike can establish profiles, expand their networks, and cultivate relationships that extend beyond their immediate social circles. This fosters a sense of community and camaraderie, providing an invaluable support system for all members.
        \n  
          Within the platform, professors can effortlessly establish private and public virtual classrooms for each of their courses. These dedicated spaces serve as a hub for sharing course materials, assigning projects and homework, and fostering discussions. Students can actively collaborate with peers, engaging in academic conversations within these purpose-built digital classrooms.
        \n  
          Furthermore, CS-Talks simplifies the process of managing assignments and projects. Educators can seamlessly assign tasks to their students through the platform, enabling students to submit their work and receive feedback and grades directly within the system. This streamlines the grading process and enhances communication between teachers and students.
        \n  
          The platform also facilitates the sharing of university-related events, workshops, seminars, and extracurricular activities, keeping members informed and engaged in campus life. Users can create event pages, RSVP, and stay updated on upcoming events, contributing to the development of a dynamic campus community.
        \n  
          In addition to event sharing, CS-Talks encourages knowledge dissemination through blogging and article publication. Members can publish articles on various academic and non-academic topics, creating a space for the exchange of ideas and expertise. This feature also serves as a platform for individuals to showcase their thoughts and talents.
        \n  
          Multimedia sharing is another integral aspect of CS-Talks. Users can effortlessly share photos, videos, and other multimedia content within their feeds or within specific interest groups, enabling them to visually document their university experiences and express their creativity.
        \n  
          Alumni engagement is facilitated as well, with former students having the opportunity to remain connected with their alma mater. They can mentor current students, provide valuable career advice, and share their post-graduation experiences, serving as a valuable resource for those preparing to enter the workforce.
        \n  
          CS-Talks is more than just a social platform; it represents a virtual campus community that bridges the gap between students and educators, promoting collaboration, knowledge sharing, and personal development. Whether seeking academic support, connecting with peers, or staying updated on campus life, CS-Talks offers a comprehensive solution for a richer university experience. Join today and become a part of the CS-Talks community, where education meets social interaction.
    `,
  },
  {
    img: ibdesk,
    type: "Desktop Application",
    for: "Braincrop",
    name: "IceBox Pantry",
    tech: "React, Electron JS, JavaScript, ContextAPI, NodeJS",
    url: "https://iceboxpantry.com/",
    desc: `The IceBox Vending Software, built using ReactJS, Electron.js, JavaScript, NodeJS and Socket.io, that brings the convenience of modern technology to vending machines. With this application, customers can seamlessly purchase their favorite food items with a variety of payment methods, including QR code scanning and card payments. 
          Gone are the days of carrying loose change or bills. This solution streamlines the purchasing process, making it both efficient and secure.\n But that's not all! We've taken it a step further. This application also enables customers to place orders in advance using their mobile devices. 
          Whether it's a quick snack or a refreshing beverage, customers can select and pre-order their items through a mobile app. Upon arriving at the vending machine, all they need to do enter the Order Code to retrieve their pre-ordered items, ensuring a swift and hassle-free experience.
          \n With the power of Latest and Modern Technologies, the vending-machine application revolutionizes the way customers interact with vending machines, providing a convenient, contactless, and efficient solution for all their cravings.`,
  },
  {
    img: ibm,
    type: "Mobile Application",
    for: "Braincrop",
    name: "IceBox Pantry",
    tech: "React Native, TypeScript, Firebase, Tailwind, Redux Toolkit, Stripe Payment",
    url: "https://play.google.com/store/apps/details?id=com.iceboxpantrymobileapp&hl=en&gl=US&pli=1",
    desc: `The IceBox Pantry Mobile Application is developed with React Native, TypeScript and Redux Toolkit designed to seamlessly complement to the cutting-edge vending machine application. With this mobile app, customers can take control of their vending experience by pre-ordering their favorite food items with ease. \n
          Imagine the convenience of selecting your desired snacks or drinks from the palm of your hand, customizing your order, and choosing the pick-up time that suits you best. The app empowers users to do just that. Whether you're planning a quick snack break or stocking up for an event, pre-ordering has never been this simple.
          \n But that's not all! This app features are gone a step further to enhance your vending experience. The app introduces a unique gifting feature, allowing customers to send personalized gift cards
          to their friends and loved ones. Whether it's a birthday celebration, a gesture of apology, or any special event, users can send gift cards with amounts that recipients can redeem for exclusive vouchers during checkouts. It's the perfect way to share the joy of delicious treats with others. \n With React Native, TypeScript, 
          Redux Toolkit, Stripe Payment, and Firebase at its core, this mobile application seamlessly integrates with the desktop platform, offering a user-friendly, convenient, and engaging vending experience.`,
  },
  {
    img: "https://fiverr-res.cloudinary.com/images/q_auto,f_auto/gigs/129325364/original/afaddcb9d7dfaaf5bff7ef04101935814665ac16/design-an-attractive-background-for-yThis-website.png",
    type: "Web Application",
    for: "Self",
    name: "Blood Bank",
    tech: "React, JavaScript, NodeJS, Redux, ExpressJS, MongoDB, Firebase",
    url: "",
    desc: `I'm thrilled to share my involvement in the "Blood Bank" project, a compassionate and life-saving initiative that leverages the power of technology to streamline the vital work of blood donation. Our platform is a testament to the potential of React, JavaScript, Redux, and Bootstrap, combining these technologies to create a platform where users can make a life-changing difference.
          \n
          With "Blood Bank," users have the opportunity to become heroes by registering themselves as donors or seekers. Donors can provide the gift of life by signing up and indicating their willingness to donate blood. Seekers, on the other hand, can search for specific blood groups with ease, helping them find potential donors quickly and efficiently.
          \n  
          What sets "Blood Bank" apart is its ability to connect donors and seekers. Through this platform, users can not only find compatible blood donors but also reach out to them to arrange meetings and blood donations. It's a remarkable way to bridge the gap between those in need and those willing to help.
          \n
          Additionally, this platform offers a directory of local blood banks, ensuring that users have access to essential resources in their city. It's a comprehensive solution that embodies the spirit of compassion and community, all powered by cutting-edge technology.`,
  },
  {
    img: gamesoft,
    type: "Web Application",
    for: "Self",
    name: "New-Agent Gamesoft",
    tech: "React, JavaScript, Bootstrap",
    url: "https://newagent-nippkh.web.app/",
    desc: `This is a comprehensive platform that serves as the ultimate hub for gaming enthusiasts and developers alike. This platform is your one-stop destination for accessing and analyzing the rankings and statistics of games. Whether you're a passionate gamer looking for your next adventure or a developer seeking valuable insights into the gaming landscape, our platform has you covered.
          \n
          With a wealth of data at your fingertips, you can explore the world of gaming in unparalleled depth. Discover the latest trending games, track their download numbers, scrutinize user ratings and reviews, and gauge their overall popularity. This project brings together the most up-to-date information on a wide range of games, empowering you to make informed decisions, uncover hidden gems, and stay ahead of industry trends.
          \n
          In a world where gaming continues to captivate audiences of all ages, this platform provides an invaluable resource for both gamers and developers. It's not just a project; it's a gateway to the dynamic and ever-evolving realm of gaming, where data-driven insights fuel your passion and drive your success.`,
  },
  {
    img: "https://png.pngtree.com/thumb_back/fh260/background/20201026/pngtree-futuristic-shape-abstract-background-chemistry-technology-concept-for-website-image_438818.jpg",
    type: "Mobile Application",
    for: "Self",
    name: "Blood Bank Mobile App",
    tech: "React Native, JavaScript, Redux, NodeJS, ExpressJS, MongoDB, Firebase",
    url: "",
    desc: `Introducing the "Blood Bank" mobile application, a powerful tool designed to extend the reach and impact of this life-saving mission. Developed using React Native, JavaScript, Redux, and Tailwind CSS, this app puts the life-saving potential of blood donation directly into the hands of users.
          \n
          With the "Blood Bank" app, registering as a donor or a seeker is a breeze, empowering users to play an active role in this noble cause. Donors can pledge their commitment to save lives, while seekers gain quick access to potential donors by searching for their desired blood group. The app's intuitive interface allows users to connect with donors and book meetings, ensuring a seamless and efficient blood donation process.
          \n        
          Furthermore, this mobile application serves as a comprehensive resource, providing users with a detailed list of local blood banks within their city. It's a one-stop destination for all blood-related information, empowering users to access critical resources when they need them most.
          \n
          Built with the latest technologies and a user-centric approach, the "Blood Bank" mobile app embodies convenience, compassion, and community. It's more than an app; it's a lifeline, bridging the gap between those who can help and those who require assistance. `,
  },
  {
    img: "https://i.pinimg.com/736x/ab/f7/de/abf7de18d534de6166c39fc2925259f0.jpg",
    type: "Web Application",
    for: "Self",
    name: "Copment",
    tech: "React, TypeScript, Redux, Node, Express, MongoDB",
    url: "",
  },
  {
    img: soh1,
    type: "Web Application",
    for: "AGS",
    name: "Soul of Hidama",
    tech: "React, TypeScript, Wallet Adapter",
    url: "https://soulofhidama.xyz/",
    desc: `The Soul Of Hidama is an exclusive art collection residing on the Solana Blockchain. Comprising 1111 fire spirits, this collection represents a fusion of art, blockchain technology, and a unique storytelling experience.
          \n
          Within the "Soul Of Hidama" project, you'll find a rich repository of information that delves into the heart of the collection. It includes comprehensive details about the stakes involved, the tantalizing rewards that await participants, the enigmatic hidamas themselves, and the intriguing categories that define this artistic journey.
          \n
          With "Soul Of Hidama," we've ventured into uncharted territory, creating an immersive and captivating platform where art enthusiasts and blockchain aficionados can unite. The collection's fire spirits are not merely static digital assets; they are vibrant pieces of a larger narrative, waiting to be explored and cherished.
          `,
  },
  {
    img: "https://png.pngtree.com/thumb_back/fh260/background/20201123/pngtree-digital-technology-low-poly-design-image_499020.jpg",
    type: "Server Application",
    for: "Self",
    name: "Blood Bank Server",
    tech: "NodeJS, Express, MongoDB",
    url: "",
    desc: `This robust server-side application that serves as the backbone of the "Blood Bank" ecosystem. Powered by Node.js, Express, and MongoDB, this project is the driving force behind all API functionalities and services. Not only does it orchestrate the core operations of the Blood Bank platform, but it also seamlessly handles the intricate backend requirements of this mobile application.
          \n
          At its core, this server-side application ensures that every interaction within the "Blood Bank" ecosystem is smooth and efficient. It manages user registration, authentication, and profile management, allowing donors and seekers to engage with confidence. Through a well-designed API, it facilitates the search for specific blood types, connecting individuals in urgent need with generous donors.
          \n
          Moreover, this server-side application plays a pivotal role in the "Blood Bank" mobile app, providing a secure and reliable foundation for the app's functionality. It handles data storage, retrieval, and synchronization, ensuring that users have access to real-time information and can connect with potential donors effortlessly.
          \n
          With Node.js, Express, and MongoDB, we've crafted a powerful and scalable backend that is essential to the life-saving mission of the "Blood Bank." This server-side application embodies the spirit of efficiency and reliability, driving this efforts to make blood donation accessible to all who require it.`,
  },
  {
    img: soh,
    type: "Web Application",
    for: "AGS",
    name: "Soul of Hidama Staking",
    tech: "React, TypeScript, Material, SCSS, Bootstrap, Wallet Adapter",
    url: "https://soulofhidama-staking.vercel.app/",
    desc: `I am excited to share my involvement in this project, a groundbreaking endeavor that offers an immersive and rewarding experience for NFT collectors and enthusiasts. In this innovative game, players and users have the opportunity to contribute their cherished NFT collections to a variety of captivating missions and quests, 
          each carefully designed to test their skills and knowledge. \n These missions include quests related to NFT lore exploration, strategic NFT trading, or even collaborative tasks that
          require the collective effort of a community of players. Each mission would have a predefined time interval during which users can contribute their NFTs to participate. \n     
          Upon successful completion of these missions, participants would be rewarded with unique and exciting treasures, ranging from rare NFTs, in-game assets, or even exclusive items that enhance their gaming experience. The beauty of "Soul Of Hidama Staking" lies in its ability to blend the world of NFT collecting with engaging gameplay, offering users an opportunity to not only showcase their prized NFTs but also embark on thrilling adventures with rewarding outcomes.`,
  },
  {
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQri_rcUUg49ezCaSJA9zHKAJS8nINTZLS1mpwuSfhTnKOqtt6nPlDz1AS2KoypQiNxNYM&usqp=CAU",
    type: "Web Application",
    for: "AR Distributors",
    name: "AR-Enterprises",
    tech: "React, JavaScript",
    url: "",
  },
];

export const aboutCardsData = [
  { numbers: `3+`, stat: "YEARS OF EXPERIENCE" },
  { numbers: `25+`, stat: "COMPLETED PROJECTS " },
  { numbers: `5+`, stat: "HAPPY CLIENTS & COMPANIES" },
  { numbers: `10+`, stat: "RECOMMENDATIONS" },
];
export const skills = [
  {
    skill: "HTML",
    percent: 0.75,
  },
  {
    skill: "CSS",
    percent: 0.7,
  },
  {
    skill: "SCSS",
    percent: 0.66,
  },
  {
    skill: "JAVASCRIPT",
    percent: 0.64,
  },
  {
    skill: "TYPESCRIPT",
    percent: 0.6,
  },
  {
    skill: "REACT",
    percent: 0.73,
  },
  {
    skill: "REACT NATIVE",
    percent: 0.7,
  },
  {
    skill: "C#",
    percent: 0.4,
  },
  {
    skill: ".NET CORE",
    percent: 0.4,
  },
  {
    skill: "NODE",
    percent: 0.25,
  },
];

export const __DANGER__VIRUS_WILL_HACK_YOUR_SYSTEM__XZQYPBMJDX__ =
  "https://v1.nocodeapi.com/arhamabeer/google_sheets/xFaQponzymHukibi?tabId=Sheet1";

export const edu = [
  {
    type: 1,
    duration: "2019-2022",
    desc: "I've completed my Bachelors Degree from here. I've also developed a social platforms for students and teachers to communicate with each other: CS-TALKS (fuuastcstalks.com)",
    company: "Federal Urdu University, Karachi",
    position: "BS Computer Science",
  },
];
export const exp = [
  {
    type: 0,
    duration: "2021-2022",
    desc: "Worked on a Web and Mobile projects. Mobile project was for booking a meeting for a workplace. It was like a online meeting scheduler. Web project was a online hiring platform like deel. ",
    company: "Work Hall",
    position: "Software Engineer",
  },
  {
    type: 0,
    duration: "2022",
    desc: "Here I worked on different Web Apps of WEB3, Crypto trading, NFTs selling and others.",
    company: "Ashtar Global Solutions",
    position: "Associate Software Engineer",
  },
  {
    type: 0,
    duration: "2022-present",
    desc: "I've worked on a Vending Machine Software and it's mobile app to pre-reserve meals.",
    company: "BrainCrop",
    position: "Software Engineer",
  },
];
